import HttpService from './baseHttp'
// 补货周期列表
export const HttpGetReplenishMentList = (data = {}) => HttpService.get('/api/v2/inboundPlanPeriod/findByPage', { params: data });
// 补货周期详情
export const HttpGetReplenishMentDetail = (data = {}) => HttpService.get('/api/v2/inboundPlanPeriod/getById', { params: data });
// 补货周期保存
export const HttpUpdateReplenishment = (data = {}) => HttpService.post('/api/v2/inboundPlanPeriod/update', data, { headers: { "Content-Type": "application/json" } });
// 删除补货周期
export const HttpDeleteReplanishment = (data = {}) => HttpService.get('/api/v2/inboundPlanPeriod/deleteById', { params: data  })
// 目的仓列表
export const HttpAddressList = (data = {}) => HttpService.get('/api/v2/address/findByPage', { params: { rows: 1000, ...data }, baseURL: process.env.VUE_APP_APIURL_FBB });